import { Injectable, NgZone } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { Action, NgxsAfterBootstrap, Selector, State, StateContext } from '@ngxs/store';
import { filter } from 'rxjs';

export class RouteToLogin {
	static readonly type = '@routeState.login';
}

export class RouteBack {
	static readonly type = '@routeState.routeBack';
}

export class InsideNavigateToUrl {
	static readonly type = '@routeState.navigateToUrl';
	constructor(public url: string) {}
}

export class RouteToInsideHome {
	static readonly type = '@routeState.insideHome';
}

export class RouteToInsideHomeStudio {
	static readonly type = '@routeState.insideHomeStudio';
}

export class RouteToInsideHomeCompetition {
	static readonly type = '@routeState.insideHomeCompetition';
}

export class RouteToSharedMedia {
	static readonly type = '@routeState.routeToSharedMedia';
}

export class RouteToSharedMediaViewAll {
	static readonly type = '@routeState.routeToSharedMediaViewAll';
	constructor(public eventsId: string) {}
}

export class RouteToSharedMediaViewEntry {
	static readonly type = '@routeState.routeToSharedMediaViewEntry';
	constructor(public eventsId: string, public entriesId: string) {}
}

export class RouteToInsideMedia {
	static readonly type = '@routeState.insideMedia';
	constructor(public fromShop?: boolean) {}
}

export class RouteToInsideMediaCompetitionViewAll {
	static readonly type = '@routeState.insideMediaCompetitionViewAll';
	constructor(public eventsId: string) {}
}

export class RouteToInsideMediaCompetitionEntryView {
	static readonly type = '@routeState.insideMediaCompetitionEntryView';
	constructor(public competitionId: string, public entriesId: string) {}
}

export class RouteToInsideMediaRecitalViewAll {
	static readonly type = '@routeState.insideMediaRecitalViewAll';
	constructor(public recitalId: string) {}
}

export class RouteToInsideMediaRecitalEntryView {
	static readonly type = '@routeState.insideMediaRecitalEntryView';
	constructor(public recitalId: string, public routineId: string) {}
}

export class RouteToInsideMediaVideoEditor {
	static readonly type = '@routeState.insideMediaVideoEditor';
	constructor(public competitionId: string, public entriesId: string, public isRecital?: boolean) {}
}

export class RouteToVideoJudges {
	static readonly type = '@routeState.videoJudges';
}

export class RouteToVideoJudgesEntryView {
	static readonly type = '@routeState.videoJudgesEntryView';
	constructor(public competitionId: string, public entriesId: string) {}
}

export class RouteToInsideShop {
	static readonly type = '@routeState.insideShop';
}

export class RouteToShopEventContent {
	static readonly type = '@routeState.shopEventContent';
	constructor(public eventsId: string) {}
}

export class RouteToShopCart {
	static readonly type = '@routeState.shopCart';
}

export class RouteToShopCheckout {
	static readonly type = '@routeState.shopCheckout';
}

export class RouteToShopCheckoutComplete {
	static readonly type = '@routeState.shopCheckoutComplete';
}

export class RouteToInsideHelp {
	static readonly type = '@routeState.insideHelp';
}

export class RouteToLiveEvents {
	static readonly type = '@routeState.insideLiveEvents';
}

export class RouteToLiveEventCompetition {
	static readonly type = '@routeState.insideLiveEventsCompetition';
	constructor(public competitionId: string) {}
}

export class RouteToLiveEventCompetitionManageEvents {
	static readonly type = '@routeState.insideLiveEventsCompetitionManageEvents';
	constructor(public competitionId: string, public eventId: string, public eventsScheduleRoomId?: string) {}
}

export class RouteToLiveEventCompetitionEventRooms {
	static readonly type = '@routeState.insideLiveEventsCompetitionEventRooms';
	constructor(public competitionId: string, public eventId: string) {}
}

export class RouteToLiveEventCompetitionEventDetails {
	static readonly type = '@routeState.insideLiveEventsCompetitionEventDetails';
	constructor(public competitionId: string, public eventId: string, public eventsScheduleRoomId?: string) {}
}

export class RouteToLiveEventCompetitionEventLiveStream {
	static readonly type = '@routeState.insideLiveEventsCompetitionEventLiveStream';
	constructor(public competitionId: string, public eventId: string, public eventsScheduleRoomId?: string) {}
}

export class RouteToLiveEventCompetitionEventLiveSchedule {
	static readonly type = '@routeState.insideLiveEventsCompetitionEventLiveSchedule';
	constructor(public competitionId: string, public eventId: string, public eventsScheduleRoomId?: string) {}
}

export class RouteToLiveEventCompetitionEventFullSchedule {
	static readonly type = '@routeState.insideLiveEventsCompetitionEventFullSchedule';
	constructor(public competitionId: string, public eventId: string, public eventsScheduleRoomId?: string) {}
}

export class RouteToLiveEventCompetitionEventMyRoutines {
	static readonly type = '@routeState.insideLiveEventsCompetitionEventMyRoutines';
	constructor(public competitionId: string, public eventId: string, public eventsScheduleRoomId?: string) {}
}

export class RouteToLiveEventCompetitionEventMyRoutinesStudios {
	static readonly type = '@routeState.insideLiveEventsCompetitionEventMyRoutinesStudios';
	constructor(public competitionId: string, public eventId: string, public eventsScheduleRoomId?: string) {}
}

export class RouteToLiveEventCompetitionEventMyRoutinesList {
	static readonly type = '@routeState.insideLiveEventsCompetitionEventMyRoutinesList';
	constructor(public competitionId: string, public eventId: string, public studioId: string, public eventsScheduleRoomId?: string) {}
}

export class RouteToInsideAccount {
	static readonly type = '@routeState.insideAccount';
}

export class RouteToVerifyEmail {
	static readonly type = '@routeState.verifyEmail';
}

export class RouteToWallet {
	static readonly type = '@routeState.routeToWallet';
}

export class RouteToWalletAddCard {
	static readonly type = '@routeState.routeToWalletAddCard';
	constructor(public currency: 'cad' | 'usd') {}
}

export class RouteToWalletEditCard {
	static readonly type = '@routeState.routeToWalletEditCard';
	constructor(public cardID: string) {}
}

export class RouteToNotifications {
	static readonly type = '@routeState.notifications';
}

export class RouteToAddNewRecital {
	static readonly type = '@routeState.addNewRecital';
}

export class RouteToPurpleMembership {
	static readonly type = '@routeState.purpleMembership';
}

export class RouteToDancebugChannel {
	static readonly type = '@routeState.dancebugChannel';
}

export class RouteToAppRating {
	static readonly type = '@routeState.appRating';
}

export enum AppUrls {
	NO_INTERNET = '/internet-issue',
	LOGIN_PAGE = '/login',
	INSIDE_HOME = '/inside/home',
	INSIDE_HOME_STUDIO = '/inside/home-studio',
	INSIDE_HOME_COMPETITION = '/inside/home-competition',
	INSIDE_SHOP = '/inside/shop',
	INSIDE_SHOP_EVENT_CONTENT = '/inside/shop/events/:eventsId',
	INSIDE_SHOP_CART = '/inside/shop/cart',
	INSIDE_SHOP_CHECKOUT = '/inside/shop/checkout',
	INSIDE_SHOP_CHECKOUT_COMPLETE = '/inside/shop/complete-checkout',
	INSIDE_MEDIA = '/inside/media',
	INSIDE_SHARED_MEDIA = '/inside/shared-media',
	INSIDE_SHARED_MEDIA_VIEW_ALL = '/inside/shared-media/events/:eventsId',
	INSIDE_SHARED_MEDIA_VIEW_ENTRY = '/inside/shared-media/events/:eventsId/entries/:entriesId',
	INSIDE_MEDIA_COMPETITION_VIEW_ALL = '/inside/media/competitions/:eventsId',
	INSIDE_MEDIA_COMPETITION_ENTRY_VIEW = '/inside/media/competitions/:competitionId/entries/:entriesId',
	INSIDE_MEDIA_RECITAL_VIEW_ALL = '/inside/media/recitals/:recitalId',
	INSIDE_MEDIA_RECITAL_ENTRY_VIEW = '/inside/media/recitals/:recitalId/routines/:routineId',
	INSIDE_MEDIA_VIDEO_EDITOR = '/inside/media/competitions/:competitionId/entries/:entriesId/video-editor',
	INSIDE_MEDIA_VIDEO_EDITOR_RECITAL = '/inside/media/recitals/:recitalId/routines/:routinesId/video-editor',
	VIDEO_JUDGES = '/inside/video-judge-critiques',
	VIDEO_JUDGES_ENTRY_VIEW = '/inside/video-judge-critiques/competitions/:competitionId/entries/:entriesId',
	INSIDE_HELP = '/inside/help',
	LIVE_EVENTS = '/inside/live-events',
	LIVE_EVENTS_COMPETITION = '/inside/live-events/competitions/:competitionId',
	LIVE_EVENTS_COMPETITION_EVENT_ROOMS = '/inside/live-events/competitions/:competitionId/events/:eventId/rooms',
	LIVE_EVENTS_COMPETITION_EVENT_DETAILS = '/inside/live-events/competitions/:competitionId/events/:eventId/rooms/:roomsId',
	LIVE_EVENTS_COMPETITION_MANAGE_EVENTS = '/inside/live-events/competitions/:competitionId/events/:eventId/rooms/:roomsId/manage-events',
	LIVE_EVENTS_COMPETITION_EVENT_LIVE_STREAM = '/inside/live-events/competitions/:competitionId/events/:eventId/rooms/:roomsId/live-stream',
	LIVE_EVENTS_COMPETITION_EVENT_LIVE_SCHEDULE = '/inside/live-events/competitions/:competitionId/events/:eventId/rooms/:roomsId/live-schedule',
	LIVE_EVENTS_COMPETITION_EVENT_FULL_SCHEDULE = '/inside/live-events/competitions/:competitionId/events/:eventId/rooms/:roomsId/full-schedule',
	LIVE_EVENTS_COMPETITION_EVENT_MY_ROUTINES = '/inside/live-events/competitions/:competitionId/events/:eventId/rooms/:roomsId/my-routines',
	LIVE_EVENTS_COMPETITION_EVENT_MY_ROUTINES_STUDIOS = '/inside/live-events/competitions/:competitionId/events/:eventId/rooms/:roomsId/my-routines/studios',
	LIVE_EVENTS_COMPETITION_EVENT_MY_ROUTINES_LIST = '/inside/live-events/competitions/:competitionId/events/:eventId/rooms/:roomsId/my-routines/studios/:studioId/routines',
	INSIDE_ACCOUNT = '/inside/account',
	VERIFY_EMAIL = '/inside/verify-email',
	WALLET = '/inside/wallet',
	WALLET_ADD_CARD = '/inside/wallet/add-card/:currency',
	WALLET_EDIT_CARD = '/inside/wallet/card/:cardID',
	NOTIFICATIONS = '/inside/notifications',
	ADD_NEW_RECITAL = '/inside/add-new-recital',
	PURPLE_MEMBERSHIP = '/inside/purple-membership',
	DANCEBUG_CHANNEL = '/inside/dancebug-channel',
	APP_RATING = '/inside/rate-app',
}

interface RoutingStateModel {
	activeUrl: AppUrls;
	canGoBack: boolean;
}

@State<RoutingStateModel>({
	name: 'RoutingState',
})
@Injectable()
export class RoutingState implements NgxsAfterBootstrap {
	constructor(private navController: NavController, private router: Router, private ngZone: NgZone) {}

	@Selector()
	static activeUrl(state: RoutingStateModel) {
		return state.activeUrl;
	}

	@Selector()
	static canGoBack(state: RoutingStateModel) {
		return state.canGoBack;
	}

	ngxsAfterBootstrap(ctx: StateContext<RoutingStateModel>): void {
		this.router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
			const appUrl = Object.values(AppUrls).find((pattern) => this.pathToRegex(pattern).test(event.urlAfterRedirects));

			const canGoBack = [
				AppUrls.LIVE_EVENTS_COMPETITION_MANAGE_EVENTS,
				AppUrls.LIVE_EVENTS_COMPETITION,
				AppUrls.WALLET_EDIT_CARD,
				AppUrls.INSIDE_SHOP_CART,
				AppUrls.INSIDE_SHOP_CHECKOUT,
				AppUrls.INSIDE_SHOP_EVENT_CONTENT,
			];

			if (appUrl) {
				ctx.patchState({ activeUrl: appUrl, canGoBack: canGoBack.includes(appUrl) });
			}
		});
	}

	pathToRegex(path: string): RegExp {
		const normalized = path
			.replace('/rooms/:roomsId', '(?:/rooms/\\d+)?')
			.replace(/:([a-zA-Z]+)/g, '\\d+');

		return new RegExp(`^${normalized}$`);
	}

	@Action(InsideNavigateToUrl)
	navigateToUrl(ctx: StateContext<RoutingStateModel>, action: InsideNavigateToUrl) {
		this.ngZone.run(async () => {
			await this.navController.navigateRoot(action.url);
		});
	}

	@Action(RouteToInsideHome)
	routeToInsideHome() {
		this.ngZone.run(async () => {
			this.navController.setDirection('root');
			await this.navController.navigateRoot(AppUrls.INSIDE_HOME, { replaceUrl: true });
		});
	}

	@Action(RouteToInsideHomeStudio)
	routeToInsideHomeStudio() {
		this.ngZone.run(async () => {
			await this.navController.navigateForward(AppUrls.INSIDE_HOME_STUDIO);
		});
	}

	@Action(RouteToInsideHomeCompetition)
	routeToInsideHomeCompetition() {
		this.ngZone.run(async () => {
			await this.navController.navigateForward(AppUrls.INSIDE_HOME_COMPETITION);
		});
	}

	@Action(RouteToSharedMedia)
	routeToSharedMedia() {
		this.ngZone.run(async () => {
			await this.navController.navigateForward(AppUrls.INSIDE_SHARED_MEDIA);
		});
	}

	@Action(RouteToSharedMediaViewAll)
	routeToSharedMediaViewAll(ctx: StateContext<RoutingStateModel>, action: RouteToSharedMediaViewAll) {
		const url = AppUrls.INSIDE_SHARED_MEDIA_VIEW_ALL.replace(':eventsId', action.eventsId);
		this.ngZone.run(async () => {
			await this.navController.navigateForward(url);
		});
	}

	@Action(RouteToSharedMediaViewEntry)
	routeToSharedMediaViewEntry(ctx: StateContext<RoutingStateModel>, action: RouteToSharedMediaViewEntry) {
		const url = AppUrls.INSIDE_SHARED_MEDIA_VIEW_ENTRY.replace(':eventsId', action.eventsId).replace(':entriesId', action.entriesId);
		this.ngZone.run(async () => {
			await this.navController.navigateForward(url);
		});
	}

	@Action(RouteToInsideMedia)
	routeToInsideMedia(ctx: StateContext<RoutingStateModel>, action: RouteToInsideMedia) {
		this.ngZone.run(async () => {
			if (action.fromShop) {
				await this.navController.navigateRoot(AppUrls.INSIDE_SHOP, { replaceUrl: true });
				await this.navController.navigateRoot(AppUrls.INSIDE_MEDIA, { replaceUrl: true });
			} else await this.navController.navigateForward(AppUrls.INSIDE_MEDIA);
		});
	}

	@Action(RouteToVideoJudges)
	routeToVideoJudges() {
		this.ngZone.run(async () => {
			await this.navController.navigateForward(AppUrls.VIDEO_JUDGES);
		});
	}

	@Action(RouteToInsideShop)
	routeToInsideShop() {
		this.ngZone.run(async () => {
			await this.navController.navigateRoot(AppUrls.INSIDE_SHOP);
		});
	}

	@Action(RouteToShopEventContent)
	routeToShopEventContent(ctx: StateContext<RoutingStateModel>, action: RouteToShopEventContent) {
		const url = AppUrls.INSIDE_SHOP_EVENT_CONTENT.replace(':eventsId', action.eventsId);
		this.ngZone.run(async () => {
			await this.navController.navigateForward(url);
		});
	}

	@Action(RouteToShopCart)
	routeToShopCart() {
		this.ngZone.run(async () => {
			await this.navController.navigateForward(AppUrls.INSIDE_SHOP_CART);
		});
	}

	@Action(RouteToShopCheckout)
	routeToShopCheckout() {
		this.ngZone.run(async () => {
			await this.navController.navigateForward(AppUrls.INSIDE_SHOP_CHECKOUT);
		});
	}

	@Action(RouteToShopCheckoutComplete)
	routeToShopCheckoutComplete() {
		this.ngZone.run(async () => {
			await this.navController.navigateForward(AppUrls.INSIDE_SHOP_CHECKOUT_COMPLETE);
		});
	}

	@Action(RouteToInsideHelp)
	async routeToInsideHelp() {
		await this.navController.navigateForward(AppUrls.INSIDE_HELP);
	}

	@Action(RouteToLogin)
	routeToLogin() {
		this.ngZone.run(async () => {
			await this.navController.navigateRoot(AppUrls.LOGIN_PAGE);
		});
	}

	@Action(RouteToLiveEvents)
	async routeToLiveEvents() {
		await this.navController.navigateForward(AppUrls.LIVE_EVENTS);
	}

	@Action(RouteToLiveEventCompetition)
	async routeToLiveEventsCompetition(ctx: StateContext<RoutingStateModel>, action: RouteToLiveEventCompetition) {
		const url = AppUrls.LIVE_EVENTS_COMPETITION.replace(':competitionId', action.competitionId);
		await this.navController.navigateForward(url);
	}

	@Action(RouteBack)
	routeBack() {
		this.ngZone.run(() => {
			this.navController.back({ animated: false });
		});
	}

	@Action(RouteToLiveEventCompetitionManageEvents)
	routeToLiveEventsCompetitionManageEvents(ctx: StateContext<RoutingStateModel>, action: RouteToLiveEventCompetitionManageEvents) {
		let url = AppUrls.LIVE_EVENTS_COMPETITION_MANAGE_EVENTS.replace(':competitionId', action.competitionId).replace(
			':eventId',
			action.eventId
		);

		if (action.eventsScheduleRoomId) {
			url = url.replace(':roomsId', action.eventsScheduleRoomId);
		} else url = url.replace('/rooms/:roomsId', '');

		this.ngZone.run(async () => {
			await this.navController.navigateForward(url);
		});
	}

	@Action(RouteToLiveEventCompetitionEventRooms)
	routeToLiveEventsCompetitionEventRooms(ctx: StateContext<RoutingStateModel>, action: RouteToLiveEventCompetitionEventRooms) {
		const url = AppUrls.LIVE_EVENTS_COMPETITION_EVENT_ROOMS.replace(':competitionId', action.competitionId).replace(
			':eventId',
			action.eventId
		);
		this.ngZone.run(async () => {
			await this.navController.navigateForward(url);
		});
	}

	@Action(RouteToLiveEventCompetitionEventDetails)
	routeToLiveEventsCompetitionEventDetails(ctx: StateContext<RoutingStateModel>, action: RouteToLiveEventCompetitionEventDetails) {
		let url = AppUrls.LIVE_EVENTS_COMPETITION_EVENT_DETAILS.replace(':competitionId', action.competitionId).replace(
			':eventId',
			action.eventId
		);

		if (action.eventsScheduleRoomId) {
			url = url.replace(':roomsId', action.eventsScheduleRoomId);
		} else url = url.replace('/rooms/:roomsId', '');

		this.ngZone.run(async () => {
			await this.navController.navigateForward(url);
		});
	}

	@Action(RouteToLiveEventCompetitionEventLiveStream)
	routeToLiveEventsCompetitionEventLiveStream(ctx: StateContext<RoutingStateModel>, action: RouteToLiveEventCompetitionEventLiveStream) {
		let url = AppUrls.LIVE_EVENTS_COMPETITION_EVENT_LIVE_STREAM.replace(':competitionId', action.competitionId).replace(
			':eventId',
			action.eventId
		);

		if (action.eventsScheduleRoomId) {
			url = url.replace(':roomsId', action.eventsScheduleRoomId);
		} else url = url.replace('/rooms/:roomsId', '');

		this.ngZone.run(async () => {
			await this.navController.navigateForward(url);
		});
	}

	@Action(RouteToLiveEventCompetitionEventLiveSchedule)
	routeToLiveEventsCompetitionEventLiveSchedule(
		ctx: StateContext<RoutingStateModel>,
		action: RouteToLiveEventCompetitionEventLiveSchedule
	) {
		let url = AppUrls.LIVE_EVENTS_COMPETITION_EVENT_LIVE_SCHEDULE.replace(':competitionId', action.competitionId).replace(
			':eventId',
			action.eventId
		);

		if (action.eventsScheduleRoomId) {
			url = url.replace(':roomsId', action.eventsScheduleRoomId);
		} else url = url.replace('/rooms/:roomsId', '');

		this.ngZone.run(async () => {
			await this.navController.navigateForward(url);
		});
	}

	@Action(RouteToLiveEventCompetitionEventFullSchedule)
	routeToLiveEventsCompetitionEventFullSchedule(
		ctx: StateContext<RoutingStateModel>,
		action: RouteToLiveEventCompetitionEventFullSchedule
	) {
		let url = AppUrls.LIVE_EVENTS_COMPETITION_EVENT_FULL_SCHEDULE.replace(':competitionId', action.competitionId).replace(
			':eventId',
			action.eventId
		);

		if (action.eventsScheduleRoomId) {
			url = url.replace(':roomsId', action.eventsScheduleRoomId);
		} else url = url.replace('/rooms/:roomsId', '');

		this.ngZone.run(async () => {
			await this.navController.navigateForward(url);
		});
	}

	@Action(RouteToLiveEventCompetitionEventMyRoutines)
	routeToLiveEventsCompetitionEventMyRoutines(ctx: StateContext<RoutingStateModel>, action: RouteToLiveEventCompetitionEventMyRoutines) {
		let url = AppUrls.LIVE_EVENTS_COMPETITION_EVENT_MY_ROUTINES.replace(':competitionId', action.competitionId).replace(
			':eventId',
			action.eventId
		);

		if (action.eventsScheduleRoomId) {
			url = url.replace(':roomsId', action.eventsScheduleRoomId);
		} else url = url.replace('/rooms/:roomsId', '');

		this.ngZone.run(async () => {
			await this.navController.navigateForward(url);
		});
	}

	@Action(RouteToLiveEventCompetitionEventMyRoutinesStudios)
	routeToLiveEventsCompetitionEventMyRoutinesStudios(
		ctx: StateContext<RoutingStateModel>,
		action: RouteToLiveEventCompetitionEventMyRoutinesStudios
	) {
		let url = AppUrls.LIVE_EVENTS_COMPETITION_EVENT_MY_ROUTINES_STUDIOS.replace(':competitionId', action.competitionId).replace(
			':eventId',
			action.eventId
		);

		if (action.eventsScheduleRoomId) {
			url = url.replace(':roomsId', action.eventsScheduleRoomId);
		} else url = url.replace('/rooms/:roomsId', '');

		this.ngZone.run(async () => {
			await this.navController.navigateForward(url);
		});
	}

	@Action(RouteToLiveEventCompetitionEventMyRoutinesList)
	routeToLiveEventsCompetitionEventMyRoutinesList(
		ctx: StateContext<RoutingStateModel>,
		action: RouteToLiveEventCompetitionEventMyRoutinesList
	) {
		let url = AppUrls.LIVE_EVENTS_COMPETITION_EVENT_MY_ROUTINES_LIST.replace(':competitionId', action.competitionId)
			.replace(':eventId', action.eventId)
			.replace(':studioId', action.studioId);

		if (action.eventsScheduleRoomId) {
			url = url.replace(':roomsId', action.eventsScheduleRoomId);
		} else url = url.replace('/rooms/:roomsId', '');

		this.ngZone.run(async () => {
			await this.navController.navigateForward(url);
		});
	}

	@Action(RouteToInsideMediaCompetitionViewAll)
	async routeToInsideMediaCompetitionViewAll(ctx: StateContext<RoutingStateModel>, action: RouteToInsideMediaCompetitionViewAll) {
		const url = AppUrls.INSIDE_MEDIA_COMPETITION_VIEW_ALL.replace(':eventsId', action.eventsId);
		await this.navController.navigateForward(url);
	}

	@Action(RouteToInsideMediaCompetitionEntryView)
	routeToInsideMediaCompetitionEntryView(ctx: StateContext<RoutingStateModel>, action: RouteToInsideMediaCompetitionEntryView) {
		const url = AppUrls.INSIDE_MEDIA_COMPETITION_ENTRY_VIEW.replace(':competitionId', action.competitionId).replace(
			':entriesId',
			action.entriesId
		);
		this.ngZone.run(async () => {
			await this.navController.navigateForward(url);
		});
	}

	@Action(RouteToInsideMediaRecitalViewAll)
	async routeToInsideMediaRecitalViewAll(ctx: StateContext<RoutingStateModel>, action: RouteToInsideMediaRecitalViewAll) {
		const url = AppUrls.INSIDE_MEDIA_RECITAL_VIEW_ALL.replace(':recitalId', action.recitalId);
		await this.navController.navigateForward(url);
	}

	@Action(RouteToInsideMediaRecitalEntryView)
	routeToInsideMediaRecitalEntryView(ctx: StateContext<RoutingStateModel>, action: RouteToInsideMediaRecitalEntryView) {
		const url = AppUrls.INSIDE_MEDIA_RECITAL_ENTRY_VIEW.replace(':recitalId', action.recitalId).replace(':routineId', action.routineId);
		this.ngZone.run(async () => {
			await this.navController.navigateForward(url);
		});
	}

	@Action(RouteToInsideMediaVideoEditor)
	routeToInsideMediaVideoEditor(ctx: StateContext<RoutingStateModel>, action: RouteToInsideMediaVideoEditor) {
		let url = '';
		if (action.isRecital) {
			url = AppUrls.INSIDE_MEDIA_VIDEO_EDITOR_RECITAL.replace(':recitalId', action.competitionId).replace(':routinesId', action.entriesId);
		} else {
			url = AppUrls.INSIDE_MEDIA_VIDEO_EDITOR.replace(':competitionId', action.competitionId).replace(':entriesId', action.entriesId);
		}
		this.ngZone.run(async () => {
			await this.navController.navigateForward(url);
		});
	}

	@Action(RouteToVideoJudgesEntryView)
	routeToVideoJudgesEntryView(ctx: StateContext<RoutingStateModel>, action: RouteToVideoJudgesEntryView) {
		const url = AppUrls.VIDEO_JUDGES_ENTRY_VIEW.replace(':competitionId', action.competitionId).replace(':entriesId', action.entriesId);
		this.ngZone.run(async () => {
			await this.navController.navigateForward(url);
		});
	}

	@Action(RouteToInsideAccount)
	async routeToInsideAccount() {
		await this.navController.navigateForward(AppUrls.INSIDE_ACCOUNT);
	}

	@Action(RouteToVerifyEmail)
	async routeToVerifyEmail() {
		await this.navController.navigateForward(AppUrls.VERIFY_EMAIL);
	}

	@Action(RouteToWallet)
	routeToWallet() {
		this.ngZone.run(async () => {
			await this.navController.navigateForward(AppUrls.WALLET);
		});
	}

	@Action(RouteToWalletAddCard)
	routeToWalletAddCard(ctx: StateContext<RoutingStateModel>, action: RouteToWalletAddCard) {
		const url = AppUrls.WALLET_ADD_CARD.replace(':currency', action.currency);
		this.ngZone.run(async () => {
			await this.navController.navigateForward(url);
		});
	}

	@Action(RouteToWalletEditCard)
	routeToWalletEditCard(ctx: StateContext<RoutingStateModel>, action: RouteToWalletEditCard) {
		const url = AppUrls.WALLET_EDIT_CARD.replace(':cardID', action.cardID);
		this.ngZone.run(async () => {
			await this.navController.navigateForward(url);
		});
	}

	@Action(RouteToNotifications)
	routeToNotifications() {
		this.ngZone.run(async () => {
			await this.navController.navigateForward(AppUrls.NOTIFICATIONS);
		});
	}

	@Action(RouteToAddNewRecital)
	routeToAddNewRecital() {
		this.ngZone.run(async () => {
			await this.navController.navigateForward(AppUrls.ADD_NEW_RECITAL);
		});
	}

	@Action(RouteToPurpleMembership)
	routeToPurpleMembership() {
		this.ngZone.run(async () => {
			await this.navController.navigateForward(AppUrls.PURPLE_MEMBERSHIP);
		});
	}

	@Action(RouteToDancebugChannel)
	routeToDancebugChannel() {
		this.ngZone.run(async () => {
			await this.navController.navigateForward(AppUrls.DANCEBUG_CHANNEL);
		});
	}

	@Action(RouteToAppRating)
	routeToAppRating() {
		this.ngZone.run(async () => {
			await this.navController.navigateForward(AppUrls.APP_RATING);
		});
	}
}
